var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{staticClass:"form-control cke_rtl",staticStyle:{"display":"none"},attrs:{"id":_vm.id,"name":_vm.name,"rows":"7"}},[_vm._v("    "+_vm._s(_vm.OldData)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }